export default "__VITE_ASSET__CNZ0tGS3__"